import { ERecommendedPackageType } from '../../types/reducers/recommendedPackages';

export interface IBuyPackagePayload {
  packageId?: number;
  packageType: ERecommendedPackageType;
  locationPath: number[];
  category: string;
  latitude: number;
  longitude: number;
}

export const buyPackageInApp = (payload: IBuyPackagePayload) => ({
  action: 'buy-package',
  payload: { ...payload },
});
